export const DOCUMENT_TITLE = `WeepyEyes Videos`;
export const APP_VERSION = import.meta.env.VITE_VERSION;
export const MIN_COMMENT_LENGTH = 3; // these should match up to backend
export const MAX_COMMENT_CHARS = 1000;
export const MAX_FEEDBACK_CHARS = 2000;

export const FACEBOOK_BASEURL = `https://www.facebook.com`;
export const INSTAGRAM_BASEURL = `https://www.instagram.com`;
export const TWITTER_BASEURL = `https://twitter.com`;
export const IMDB_BASEURL = `https://www.imdb.com`;
export const PATREON_OAUTH2_URL = `https://www.patreon.com/oauth2/authorize`;

export const OUR_PATREON_PAGE_URL = `https://www.patreon.com/weepyeviesanne`;
export const PATREON_CLIENT_ID = import.meta.env.VITE_PATREON_CLIENT_ID;
export const PATREON_REDIRECT_URI = `${window.location.origin}/auth/patreon`;

// staleTime for react-query in milliseconds.
export const LIBRARY_STALETIME = 1000 * 60 * 2;
export const LIBRARY_ITEM_STALETIME = 1000 * 60 * 2; // also used with /paths rpc
export const LIBRARY_STATE_STALETIME = 1000 * 60 * 2;
export const PERSON_STALETIME = 1000 * 60 * 2;
export const PEOPLE_STALETIME = 1000 * 60 * 2;
export const NOTIFICATIONS_STALETIME = 1000 * 60 * 1;
export const HUBS_STALETIME = 1000 * 60 * 1;
export const DEFAULT_STALETIME = 1000 * 60 * 1;

export const links = {
  library_item: {
    path: "/d/item/:id",
  },
  folders: "/d",
  folder: "/d/:folder",
  // library_story: "/d/:library/:id_or_slug",
  story: "/story/:slug",
  person: "/person/:id",
  people: "/people",
  feed: "/feed",
  list: "/list/:slug",
  lists: "/lists",
  manage: "/manage",
  manage_stories: "/manage/stories",
  manage_titleitem_automatches: "/manage/title-items/matches",
  manage_images: "/manage/images",
  manage_feedback: "/manage/feedback",
  manage_events: "/manage/events",
  // manage_changelog: "/manage/changelog",
  // manage_titles: "/manage/remote-titles",
  settings: "/settings",
  patreon_redirect: "/auth/patreon",
  calendar: "/calendar",
  // feedback: "/feedback",
} as const; // need as const for make() fn types to work properly with this.path in generatePath

// export const LIBRARIES: { folder_name: string; http_path_name: string; new: boolean | null }[] = [
//   { http_path_name: "shorts", folder_name: "Shorts", new: false },
//   { http_path_name: "movie-couples", folder_name: "Movie Couples", new: false },
//   { http_path_name: "tvweb-shows", folder_name: "TV/Web Shows", new: false },
//   { http_path_name: "tvweb-couples", folder_name: "TV/Web Couples", new: false },
//   { http_path_name: "subtext", folder_name: "Women & Subtext", new: false },
//   { http_path_name: "lgbtq-eps", folder_name: "LGBTQ Episodes Only", new: false },
//   { http_path_name: "lgbtq-animation", folder_name: "LGBTQ Animation", new: false },
//   // {http_path_name: 'test-lib', folder_name: 'Test Lib'},
// ];

// export const CACHE_PREFETCH = {
//   libraries: true,
//   libraryState: true,
// } as const;

export const storageKeys = {
  pushsub: "pushsub",
  pushsubrefreshed: "pushsub.refreshed",
  quickSearchHistory: "QuickSearchHistory",
} as const;

/** _DB_: [_DB_, _TMDB_] */
export const mediaTypeMap = {
  movie: ["movie", "movie"],
  series: ["series", "tv"],
} as const;
export type MediaTypeMap = keyof typeof mediaTypeMap;
